module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-63.165271bb.svg";